import { Component } from '@opten/compiler/metadata/component';
import { parseCssUnit } from '@opten/number/parse-css-unit';
import { getCss } from '@opten/dom/get-css';

import { PAD_WIDTH } from '../utilities/detection';
import { getStickyOffset } from '../utilities/scroll-helper';

import { crossSelling } from '@opten/cross-selling';

@Component({ className: 'js-cross-selling' })
export default class CrossSelling {
    constructor(private element: HTMLElement) {
        let gutterBottom = 0;
        gutterBottom += parseCssUnit(getCss(element, 'margin-top'));
        gutterBottom += parseCssUnit(getCss(element, 'margin-bottom'));

        crossSelling(element, {
            gutterTop: getStickyOffset(),
            gutterBottom: Math.round(gutterBottom),
            breakpoints: {
                maxWidth: PAD_WIDTH
            }
        });
    }
}
